import {
  FILTER_KEY_CALENDARS,
  FILTER_KEY_EVENT_TYPES,
  FILTER_KEY_GEOGRAPHY_SLUGS,
  FILTER_KEY_INCLUDE_VIRTUAL,
  FILTER_KEY_LABELS,
  FILTER_KEY_LOCATION,
  FILTER_KEY_REGIONS,
  FILTER_KEY_START_DATE_RANGE,
  FILTER_KEY_TYPES,
  FILTER_KEY_UPCOMING_ONLY
} from './filter-keys'

export const withLocalListMixin = {
  props: {
    filterOptions: {
      type: Object,
      required: true
    },
    includeSearchField: {
      type: Boolean,
      required: false,
      default: true
    },
    showEventTypeFilter: {
      type: Boolean,
      required: true
    },
    showLabelFilter: {
      type: Boolean,
      required: true
    },
    showRegionFilter: {
      type: Boolean,
      required: true
    },
    showTypeFilter: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      urlFilterKeys: [FILTER_KEY_CALENDARS, FILTER_KEY_EVENT_TYPES, FILTER_KEY_GEOGRAPHY_SLUGS, FILTER_KEY_INCLUDE_VIRTUAL,
                      FILTER_KEY_LABELS, FILTER_KEY_LOCATION, FILTER_KEY_REGIONS, FILTER_KEY_START_DATE_RANGE,
                      FILTER_KEY_TYPES, FILTER_KEY_UPCOMING_ONLY]
    }
  },

  created() {
    this.$store.commit('setUrlFilterKeys', this.urlFilterKeys)
    this.$store.commit('setSearchStrategy', this.searchStrategy)
    this.$store.commit('setOptionsFromUrlAndFilters', this.propFiltersNotForUrl)
    this.$store.commit('setFilterOptions', this.filterOptions)
    this.$store.dispatch('loadDataFromUrl')
  },

  computed: {
    allowedAdvancedFilters() {
      const allowed = [FILTER_KEY_INCLUDE_VIRTUAL, FILTER_KEY_START_DATE_RANGE]

      if (this.showEventTypeFilter) {
        allowed.push(FILTER_KEY_EVENT_TYPES)
      }

      if (this.showLabelFilter) {
        allowed.push(FILTER_KEY_LABELS)
      }

      if (this.showRegionFilter) {
        allowed.push(FILTER_KEY_REGIONS)
      }

      return allowed
    }
  },

  methods: {
    onPaginate() {
      this.$refs.list.$el.scrollTop = 0
    }
  }
}
